import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import {BASE_PATH} from "@/components/constants";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // @ts-ignore
        backend: {
            // translation file path
            loadPath: `${BASE_PATH}/src/translations/{{ns}}/{{lng}}.json`,
        },
        fallbackLng: "en",
        // please disable debug in production
        debug: false,
        //ns means namespace. It is used to group translations into different files.
        // can have multiple namespaces, in case you want to divide a huge
        // translation into smaller pieces and load them on demand
        ns: ["global"],
        interpolation: {
            espaceValue: false,
            formatSeparator: ",",
        },
        react: {
            wait: true,
        },
    });
export default i18n;